import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './app/App';
import './index.css';

// Vite hashes every lazy-loaded page chunk per build (e.g. EmployeesPage-<hash>.js).
// A tab left open across a deploy still references the old hash, which 404s
// the moment the user navigates to a page they haven't visited yet in this
// session ("Failed to fetch dynamically imported module") — a jarring crash
// screen for what's really just a stale build reference. Reload once to pick
// up the new build automatically instead. Guarded by sessionStorage so a
// genuine repeated failure (bad deploy, real network issue) can't loop
// reloads forever — it degrades to today's "refresh manually" behavior.
window.addEventListener('vite:preloadError', () => {
  const key = 'vite-reload-on-preload-error';
  if (sessionStorage.getItem(key)) return;
  sessionStorage.setItem(key, '1');
  window.location.reload();
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
